import { Route } from '@angular/router';
import {
  AppConfig,
  CadastrarComponent,
  EditarComponentComponent,
  loggedInGuard,
  LoginComponent,
  RecuperarSenhaComponent,
  SistemaEnum,
} from '@nomoh-monorepo/shared-common-ui';
import { MinhaContaPageComponent } from './minha-conta-page/minha-conta-page.component';

const NOMOH_CLIENTE_CONFIG: AppConfig = {
  app: 'nomoh-cliente',
  title: 'Nomoh Cliente',
  theme: 'nomoh-cliente-theme',
  dashboardRoute: '/',
  sistema: SistemaEnum.NomohCliente,
};

export const appRoutes: Route[] = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loggedInGuard],
    data: { appConfig: NOMOH_CLIENTE_CONFIG },
  },
  {
    path: 'recuperar-senha',
    component: RecuperarSenhaComponent,
    data: { appConfig: NOMOH_CLIENTE_CONFIG },
  },
  {
    path: 'cadastrar',
    component: CadastrarComponent,
    data: { appConfig: NOMOH_CLIENTE_CONFIG },
  },
  {
    path: 'minha-conta/:pessoaId',
    component: MinhaContaPageComponent,
  },
  {
    path: 'minha-conta/:pessoaId/ajuda',
    loadComponent: () =>
      import('@nomoh-monorepo/nomoh-cliente-feature-ajuda').then(
        (m) => m.FeatureAjudaHubComponent
      ),
  },
  {
    path: 'minha-conta/:pessoaId/ajuda/novo',
    loadComponent: () =>
      import('@nomoh-monorepo/nomoh-cliente-feature-ajuda').then(
        (m) => m.FeatureAjudaNovoComponent
      ),
  },
  {
    path: 'minha-conta/:pessoaId/ajuda/chamados',
    loadComponent: () =>
      import('@nomoh-monorepo/nomoh-cliente-feature-ajuda').then(
        (m) => m.FeatureAjudaChamadosComponent
      ),
  },
  {
    path: 'minha-conta/:pessoaId/ajuda/chamados/:chamadoId',
    loadComponent: () =>
      import('@nomoh-monorepo/nomoh-cliente-feature-ajuda').then(
        (m) => m.FeatureAjudaDetalheComponent
      ),
  },
  {
    path: 'editar/:id',
    component: EditarComponentComponent,
  },
  {
    path: 'privacidade',
    loadComponent: () =>
      import('@nomoh-monorepo/shared-common-ui').then(
        (m) => m.PrivacidadeComponent
      ),
    data: { systemName: 'Nomoh Cliente' },
  },
  {
    path: 'plano-expirado',
    loadComponent: () =>
      import('@nomoh-monorepo/shared-common-ui').then(
        (m) => m.PlanoExpiradoComponent
      ),
  },
  {
    path: 'bardo',
    loadComponent: () =>
      import('@nomoh-monorepo/nomoh-cliente-feature-bardo').then(
        (m) => m.FeatureBardoComponent
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('@nomoh-monorepo/nomoh-cliente-feature-home').then(
        (m) => m.FeatureHomeComponent
      ),
  },
];
